import { createBrowserHistory } from "history";
export var history = createBrowserHistory();
